import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { changeStaff } from '../../../../actions/staff';
import { TYPE_BUTTONS, USERS_LIST } from '../../../../constans';
import Row from '../../../Basic/Blocks/Row';
import Button from '../../../Basic/Buttons/Button';
import H2 from '../../../Basic/WrapsStyle/H/H2';

import UserApi from '../../../../API/user/user-api';
import { Column } from '../../../Basic/Blocks';
import PopUp from '../../../Basic/Blocks/PopUp';
import Input from '../../../Basic/Inputs/Base';
import Select from '../../../Basic/Inputs/Select';
import styles from './styles.module.scss';

const ChangeUserPopUp = ({ user = {}, close = () => { } }) => {
  const dispatch = useDispatch();
  const [data, setData] = useState({
    name: '',
    role: Object.keys(USERS_LIST)[0],
    rates: {
      pick: 3,
    },
  });

  const [valid, setValid] = useState({
    name: '',
  });

  const disabled_button = !(data.name.length > 0);

  const validate = () => {
    if (!disabled_button) {
      return true;
    } else {
      setValid({
        name: data.name.length > 0 ? '' : 'Заполни поле ',
      });
      return false;
    }
  };

  /// фикс
  const clickChange = () => {
    if (validate()) {
      UserApi.changeUser({ data: { login: user.login, data: data } })
        .then((r) => {
          dispatch(changeStaff(r.data.login, r.data));
          close();
        })
        .catch((err) => console.log(err));
    }
  };

  useEffect(() => {
    setData({ name: user.name, role: user.role, rates: user.rates, scanerId: user.scanerId });
  }, [user]);

  return (
    <PopUp close={close} clickOutside={false} className={styles.pop_up}>
      <H2>Изменить данные о сотруниднике</H2>
      <Input
        value={data.name}
        error={valid.name}
        label="Имя"
        width="80%"
        onChange={(v) => setData({ ...data, name: v })}
        style={{ marginBottom: '15px' }}
      />
      <Row style={{ alignItems: 'flex-end' }}>
        {user.role !== 'owner' && (
          <Select
            select={data.role}
            label="Должность"
            width="250px"
            onSelect={(v) => setData({ ...data, role: v })}
            list={Object.keys(USERS_LIST)}
            valueFn={(v) => USERS_LIST[v].name}
            style={{ marginRight: '20px' }}
          />
        )}
        <Input
          value={data.scanerId}
          error={valid.name}
          showLabe={true}
          label="Номер сканера"
          width="150px"
          onChange={(v) => setData({ ...data, scanerId: v })}
        />
      </Row>
      <Row style={{ marginTop: '30px' }}>
        {['packer'].includes(user.role) && (
          <Column>
            Ставки
            <Input
              label={'Пропик пикальщика'}
              value={data.rates?.pick}
              onBlur={(v) => setData({ ...data, rates: { ...data.rates, pick: parseFloat(v) } })}
              width={'110px'}
              style={{ marginRight: '15px' }}
            />
            <Input
              label={'Обработка экспресса'}
              value={data.rates?.pick_express}
              onBlur={(v) => setData({ ...data, rates: { ...data.rates, pick_express: parseFloat(v) } })}
              width={'130px'}
              style={{ marginRight: '15px' }}
            />
            <Input
              label={'Сборка резерва'}
              value={data.rates?.reserve_assembly}
              onBlur={(v) => setData({ ...data, rates: { ...data.rates, reserve_assembly: parseFloat(v) } })}
              width={'130px'}
              style={{ marginRight: '15px' }}
            />
            <Input
              label={'Занесение с отгрузки'}
              value={data.rates?.entry_overage}
              onBlur={(v) => setData({ ...data, rates: { ...data.rates, entry_overage: parseFloat(v) } })}
              width={'130px'}
              style={{ marginRight: '15px' }}
            />
            <Input
              label={'Занесение с возвратов'}
              value={data.rates?.entry_return}
              onBlur={(v) => setData({ ...data, rates: { ...data.rates, entry_return: parseFloat(v) } })}
              width={'110px'}
              style={{ marginRight: '15px' }}
            />
            <Input
              label={'Занесение от поставщика'}
              value={data.rates?.entry_entrying}
              onBlur={(v) => setData({ ...data, rates: { ...data.rates, entry_entrying: parseFloat(v) } })}
              width={'110px'}
              style={{ marginRight: '15px' }}
            />
          </Column>
        )}
      </Row>





      <Row style={{ marginTop: '30px' }}>
        <Button
          type={TYPE_BUTTONS.BLUE}
          style={{ marginRight: '20px' }}
          disabled={disabled_button}
          onClick={disabled_button ? () => { } : clickChange}
        >
          Сохранить
        </Button>
        <Button type={TYPE_BUTTONS.GREY} onClick={close}>
          Отменить
        </Button>
      </Row>
    </PopUp>
  );
};

export default ChangeUserPopUp;
